<template>
  <div class="arround_list">
    <div class="arround_list_card">
      <div class="van-form_box">
        <div>
          <div class="header">
            <p>图片凭证</p>
            <p>{{ receveImageData.length }}/3</p>
          </div>
          <div class="form_info">
            <div class="form_many">
              <ManyImg
                :uploadData="receveImageData"
                @base64Upload="base64Upload($event)"
                @previewImg="previewImg"
              />
            </div>
          </div>
          <div class="form_info_tips">请上传可证明过往工作经验的截图（包括但不限于司机端截图）</div>
        </div>
      </div>
      <div class="around">
        <div class="header">
          <p>过往工作代驾公司</p>
        </div>
        <div class="arround_componay">
           <van-field  @input="handleInclude" v-model="companyName" class="arround_componay_field"  placeholder="请输入公司名称"  maxlength="15"/>
        </div>
        <div class="around_componay_time">
          <div class="header">
            <p>过往工作时间</p>
          </div>
          <div class="around_componay_time_control">
            <div :class="startTime ? 'around_start_check' : 'around_start'" @click="handleStart">
              {{startTime || '开始时间'}}
            </div>
            <span>至</span>
            <div :class="endTime ? 'around_end_check' :'around_end'" @click="handleEnd">
              {{endTime || '结束时间'}}
            </div>
          </div>
          <div class="around_componay_time_tips">
            友情提示：信息更完整，审核更高效哦
          </div>
      </div>
      </div>
    </div>
    <van-popup v-model="showDatePicker" position="bottom">
       <DateTimePicker v-if="showDatePicker" :showDatePicker='showDatePicker' :minDate='minDate' :maxDate='maxDate' @confirm="onConfirmDate" @cancel='onCancel' :currentDate='currentDate'></DateTimePicker>
    </van-popup>
  </div>
</template>

<script>
import ManyImg from "../../../components/manyImg";
import dayjs from "dayjs"
import DateTimePicker from '../../../components/dateTimePicker'
import { axiosUploadExt } from "@/utils/uploadApi.js";
import { Toast } from 'vant';
export default {
  props: {
    receveImageData: {
      type: Array,
      default: () => {},
    },
    token: {
      type: String,
      default: "",
    },
    companyNames: {
      type: String,
      default: ''
    },
    startTimes: {
      type: String,
      default: ''
    },
    endTimes: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      companyName: "",
      startTime: '',
      endTime: '',
      showDatePicker: false,
      minDate: dayjs(new Date(2000, 0, 1)).format('YYYY-MM-DD'),
      maxDate: dayjs(new Date()).format('YYYY-MM-DD'),
      currentDate: new Date(),
      pickerType: ''
    };
  },
  created() {
    this.companyName = this.companyNames
    if (!this.startTimes || !this.endTimes) {
      this.startTime = ''
      this.endTime = ''
    } else {
      this.startTime = dayjs(this.startTimes && this.startTimes).format('YYYY-MM-DD')
      this.endTime = dayjs(this.endTimes && this.endTimes).format('YYYY-MM-DD')
    }
  },
  mounted() {
  },
  components: {
    ManyImg,
    DateTimePicker
  },
  computed: {
    includeSpecial() {
      return function (value) {
        const regStr =/[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF][\u200D|\uFE0F]|[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF]|[0-9|*|#]\uFE0F\u20E3|[0-9|#]\u20E3|[\u203C-\u3299]\uFE0F\u200D|[\u203C-\u3299]\uFE0F|[\u2122-\u2B55]|\u303D|[\A9|\AE]\u3030|\uA9|\uAE|\u3030/gi;
        this.companyName = value.replace(regStr, "");
      };
    },
  },
  methods: {
    handleInclude() {
      if (this.includeSpecial(this.companyName)) {
        return;
      }
      this.$emit("receveMsg", this.companyName);
    },
    previewImg(data) {
      this.$emit("previewImg", data, this.uploadData);
    },
    handleStart () {
      this.pickerType = 'start'
      this.minDate = new Date(2000, 0, 1),
      this.maxDate = new Date(),
      this.showDatePicker = true
    },
    handleEnd () {
      if (!this.startTime) {
        Toast('请选选择开始时间')
        return
      }
      this.pickerType = 'end'
      this.minDate = new Date(this.startTime)
      let currentYear = new Date().getFullYear() + 10
      this.maxDate = new Date(currentYear, 0, 1)
      this.showDatePicker = true
    },
    onConfirmDate (data) {
      if (this.pickerType == 'start') {
        this.startTime = data.value
      } else if (this.pickerType == 'end') {
        this.endTime = data.value
        this.$emit('receveTime', {startTime:this.startTime, endTime: this.endTime})
      }
      console.log(data , 'ppopop')
      this.showDatePicker = false
    }, 
    onCancel () {
      this.showDatePicker = false
    },
    // 上传
    base64Upload(key) {
      const toastOne = this.$toast({
        message: "上传中",
        overlay: true,
        duration: 0,
        forbidClick: true,
        loadingType: "spinner",
      });
      const url = this.token
        ? `/h5/v1/common/upload/base64?group=H5&module=H5ActiveGroup&cdn=false&token=${this.token}`
        : "/h5/v1/common/upload/base64?group=H5&module=H5ActiveGroup&cdn=false";
      axiosUploadExt({
        url: url,
        method: "post",
        headers: {
          "Content-Type": "text/plain",
        },
        data: key.serveSrc,
      }).then((res) => {
          toastOne.clear();
          if (res.code !== 1) {
            this.$toast(res.msg);
          }
          // 判断服务返回的地址是否含有参数
          this.$emit("receveData", {
            base64Url: `data:image/png;base64,${key.serveSrc}`,
            url: res.data,
          });
        })
        .catch((err) => {
          toastOne.clear();
          this.$toast("上传失败，请重新上传");
        });
    },
  },
};
</script>

<style lang='less' scoped>
/deep/ .van-cell {
  padding: 0;
}
/deep/ .van-field__control {
  font-size: 40px;
  color: #333333 !important;
  font-size: 28px;
}
.van-form_box {
  background: #ffffff;
  margin: 0 auto;
  border-top-left-radius: 24px;
  border-top-right-radius: 24px;
  padding:22px 0px 34px;
  // font-weight: bold;
  .header {
    display: flex;
    height: 80px;
    justify-content: space-between;
    font-size: 32px;
    color: rgba(0, 0, 0, 0.9);
    padding: 0px 24px;
    p {
      span {
        font-size: 24px;
        color: #333333;
        font-weight: 400;
        margin-left: 20px;
      }
    }
    p:nth-of-type(1)::before {
      content: "";
      width: 6px;
      height: 26px;
      display: inline-block;
      vertical-align: -1px;
      background: #47526d;
      margin-right: 4px;
    }
    p:nth-of-type(2) {
      font-size: 28px;
      color: rgba(0, 0, 0, 0.6);
      font-weight: 400;
    }
  }
}
.around {
  background: #ffffff;
  margin: 0 auto;
  margin-bottom: 30px;
  border-bottom-left-radius: 14px;
  border-bottom-right-radius: 14px;
  .header {
    display: flex;
    height: 80px;
    justify-content: space-between;
    font-size: 32px;
    // font-weight: bold;
    color: rgba(0, 0, 0, 0.9);
    padding: 0px 24px;
    p {
      span {
        font-size: 24px;
        color: #333333;
        font-weight: 400;
        margin-left: 20px;
      }
    }
    p:nth-of-type(1)::before {
      content: "";
      width: 6px;
      height: 26px;
      display: inline-block;
      vertical-align: -1px;
      background: #47526d;
      margin-right: 4px;
    }
  }
}
.bottom_btn {
  width: 590px;
  height: 96px;
  background: #c8c9cd;
  border-radius: 16px;
  margin: 0 auto;
  border: none;
  font-size: 32px;
}
.bottom_btn_blue {
  background-image: linear-gradient(270deg, #27a0ff 0%, #176af0 100%);
}
.form_info_tips{
  width: 662px;
  margin: 0 auto;
  font-size: 24px;
  color: rgba(0,0,0,0.60);
  line-height: 34px;
  border-bottom: 1px solid #f5f5f5;
  padding-bottom: 34px;
  font-weight: 400;
}
.arround_componay{
  width: 662px;
  background: #FAFAFA;
  border: 1px solid rgba(238,238,238,1);
  border-radius: 12px;
  padding-left:24px;
  margin: 0 auto;
  .arround_componay_field{
    height: 78px;
    width: 96%;
    line-height: 78px;
    background: none;
  }
}
.around_componay_time{
  margin-top:36px;
  .around_componay_time_control{
    display: flex;
    align-items: center;
    padding-left:24px;
    padding-bottom: 40px;
    color: #333333;
    span{
      font-size: 32px;
      color: #333333;
      display: inline-flex;
      margin:0 20px;
    }
    
    .around_start, .around_end, .around_start_check,.around_end_check{
      width: 294px;
      height: 70px;
      background: #FAFAFA;
      border: 1px solid rgba(238,238,238,1);
      border-radius: 12px;
      font-size:26px;
      line-height: 70px;
      padding-left:24px;
      color: #9f9f9f;
    }
    .around_start_check,.around_end_check{
      color: #333333;
    }
  }
  .around_componay_time_tips{
    font-size: 24px;
    color: rgba(0,0,0,0.60);
    padding-left:24px;
    padding-bottom: 38px;
  }
}
</style>